<div class="container-fluid home-container">
  <!-- Logo and Welcome Section -->
  <div class="row justify-content-center mb-4">
    <div class="col-12 text-center">
      <img src="assets/clareo-logo.svg" alt="Clareo logo" class="logo mb-3" />
    </div>
  </div>

  <!-- User Profile Section -->
  @if (credentialsService.credentials() && userProfile) {
  <div class="row justify-content-center mb-4">
    <div class="col-lg-10 col-xl-8">
      <div class="card user-profile-card">
        <div class="card-body">
          <h4 class="welcome-text">Welcome, {{ userProfile.name }}</h4>
          <div class="user-details">
            <p class="mb-1"><strong>Company:</strong> {{ userProfile.company }}</p>
            <p class="mb-0"><strong>Email:</strong> {{ userProfile.email }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Projects Table Section -->
  @if (credentialsService.credentials() && projectSummaries.length > 0) {
  <div class="row justify-content-center">
    <div class="col-lg-10 col-xl-8">
      <div class="card projects-card">
        <div class="card-header">
          <h5 class="mb-0">Your Projects</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-hover projects-table">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Description</th>
                  <th class="text-center">Capture Analysis</th>
                  <th class="text-center">FLAIRR Analysis</th>
                  <th class="text-center">Total Samples</th>
                </tr>
              </thead>
              <tbody>
                @for (project of projectSummaries; track project) {
                <tr>
                  <td class="project-name">{{ project.project_name }}</td>
                  <td class="project-description">{{ project.project_description }}</td>
                  <td class="text-center">
                    <span
                      class="badge clickable-badge"
                      [class.bg-info]="project.capture_samples > 0"
                      [class.bg-secondary]="project.capture_samples === 0"
                      [class.disabled]="project.capture_samples === 0"
                      (click)="project.capture_samples > 0 && navigateToCaptureAnalysis(project.project_id)"
                      [title]="
                        project.capture_samples > 0 ? 'Click to view Capture analysis' : 'No Capture analysis available'
                      "
                    >
                      {{ project.capture_samples }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      class="badge clickable-badge"
                      [class.bg-success]="project.flairr_samples > 0"
                      [class.bg-secondary]="project.flairr_samples === 0"
                      [class.disabled]="project.flairr_samples === 0"
                      (click)="project.flairr_samples > 0 && navigateToFlairrAnalysis(project.project_id)"
                      [title]="
                        project.flairr_samples > 0 ? 'Click to view FLAIRR analysis' : 'No FLAIRR analysis available'
                      "
                    >
                      {{ project.flairr_samples }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      class="badge bg-primary clickable-badge"
                      (click)="navigateToSamples(project.project_id)"
                      title="Click to view samples"
                    >
                      {{ project.total_samples }}
                    </span>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- No Projects Message -->
  @if (credentialsService.credentials() && projectSummaries.length === 0) {
  <div class="row justify-content-center">
    <div class="col-lg-8">
      <div class="card text-center">
        <div class="card-body">
          <p class="mb-0">No projects available. Please contact your administrator.</p>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Not Logged In Section -->
  @if (!credentialsService.credentials()) {
  <div class="row justify-content-center">
    <div class="col-sm-6">
      <div class="card text-center border-0">
        <div class="card-body">
          <h5 class="card-title mb-3">Welcome to Clareo Portal</h5>
          <p class="mb-3">Please log in to view your sequencing data and analysis results.</p>
          <button type="button" class="btn btn-primary" routerLink="/login">Login</button>
        </div>
      </div>
    </div>
  </div>
  }
</div>
